import { render } from "./SupplierGradeCheckbox.vue?vue&type=template&id=66cb5e78&scoped=true&ts=true&lang=pug"
import script from "./SupplierGradeCheckbox.vue?vue&type=script&lang=ts"
export * from "./SupplierGradeCheckbox.vue?vue&type=script&lang=ts"

import "./SupplierGradeCheckbox.vue?vue&type=style&index=0&id=66cb5e78&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cb5e78"]])

export default __exports__